class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = section.id === 'cart-notification-product'
        ? this.getAddedProductHTML(parsedState)
        : this.getSectionInnerHTML(parsedState.sections?.[section.id], section.selector);
      if (target && html !== null) target.innerHTML = html;
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getAddedProductHTML(item) {
    const html = item.sections?.['cart-notification-product'];
    if (html) {
      const document = new DOMParser().parseFromString(html, 'text/html');
      const exactMatch = document.getElementById(`cart-notification-product-${item.key}`);
      if (exactMatch) return exactMatch.innerHTML;

      // Cart transforms can change a line key between the add response and section rendering.
      const propertiesKey = (properties) => JSON.stringify(Object.entries(properties || {}).sort(([a], [b]) => a.localeCompare(b)));
      const planId = String(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || '');
      const candidates = [...document.querySelectorAll('[data-variant-id]')].filter((element) =>
        element.dataset.variantId === String(item.variant_id || item.id) && element.dataset.sellingPlan === planId
      );
      const matched = candidates.find((element) => {
        try { return propertiesKey(JSON.parse(element.dataset.properties)) === propertiesKey(item.properties); }
        catch { return false; }
      }) || (candidates.length === 1 ? candidates[0] : null);
      if (matched) return matched.innerHTML;
    }

    // Still acknowledge the confirmed add if Shopify could not render its notification section.
    const content = document.createElement('div');
    const title = document.createElement('h3');
    title.className = 'cart-notification-product__name h4';
    title.textContent = item.product_title || item.title || '';
    content.appendChild(title);
    const options = document.createElement('dl');
    Object.entries(item.properties || {}).forEach(([name, value]) => {
      if (name.startsWith('_') || value === '' || value == null) return;
      const option = document.createElement('div');
      option.className = 'product-option';
      const label = document.createElement('dt');
      label.textContent = `${name}:`;
      const description = document.createElement('dd');
      description.textContent = String(value);
      option.append(label, description);
      options.appendChild(option);
    });
    content.appendChild(options);
    return content.outerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML ?? null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
